import { useParams } from 'react-router-dom'
import ModuleAccountDetailIndex from './index'
const ModuleAccountDetail = () => {
  const { address } = useParams()
  return <ModuleAccountDetailIndex key={address} />
}

export default ModuleAccountDetail
